const Cover = () => (
  <p>
    svgwithme.com
    {/* <br /> Code along on Chrome or Firefox */}
  </p>
);

export default Cover;
